import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classnames from 'classnames'
import styles from './HeaderStatistic.icss'

class HeaderStatistic extends React.Component {
	render() {
		const { classNames = { button: '' } } = this.props

		const button = () => (
			<button type="button" onClick={this.props.onClick} className={classnames(styles.button, classNames.button)}>
				<div className={styles.count}>{this.props.count || 0}</div>
				<div className={styles.name}>{this.props.name}</div>
			</button>
		)
		const anchorProps = this.props.anchorProps

		return (
			<>
				{anchorProps ? <Link className={styles.link} to={anchorProps.href} {...anchorProps}>{button()}</Link> : button()}
			</>
		)
	}
}

HeaderStatistic.propTypes = {
	name: PropTypes.string,
	anchorProps: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	count: PropTypes.number,
	onClick: PropTypes.func,
	classNames: PropTypes.object 	// eslint-disable-line react/forbid-prop-types
}

HeaderStatistic.defaultProps = {
	name: null,
	anchorProps: undefined,
	count: null,
	onClick: () => {},
	classNames: undefined
}

export default HeaderStatistic



// WEBPACK FOOTER //
// ./src/components/HeaderStatistic.jsx